import { createAction, props } from '@ngrx/store';
import { CartRequest } from '../../models';
import { SkyClubEntity } from '../../models/sky-club.entities';

// API actions
export const loadPurchaseContent = createAction(
  '[Purchase Pass/API] Load Purchase Pass Content'
);

export const loadPurchaseContentSuccess = createAction(
  '[Purchase Pass/API] Load Purchase Pass Content Success',
  props<{ data: SkyClubEntity }>()
);

export const loadPurchaseContentFail = createAction(
  '[Purchase Pass/API] Load Purchase Pass Content Fail',
  props<{ error: SkyClubEntity }>()
);

export const loadAddToCart = createAction(
  '[Sky-Club/Add to cart API] Load Add To Cart',
  props<{ data: CartRequest }>()
);

export const loadAddToCartSuccess = createAction(
  '[Sky-Club/Add to cart API] Load Add To Cart success',
  props<{ data: SkyClubEntity }>()
);

export const loadAddToCartFail = createAction(
  '[Sky-Club/Add to cart API] Load Add To Cart Fail',
  props<{ error: SkyClubEntity }>()
);
